<template>
    <v-btn flat @click="onClick" :icon="isButtonIcon" :ripple="isButtonRipple" :color="iconColor">
        <v-badge overlap right :color="badgeColor" :bottom="badgeBottom">
            <template v-if="badge" v-slot:badge>
                <span v-if="amount > 0">{{amount}}</span>
            </template>

            <v-icon v-if="amount > 0" medium>
                {{basketIcon}}
            </v-icon>

            <v-icon v-else medium>
                {{basketEmptyIcon}}
            </v-icon>
        </v-badge>

        <span class="button-label">{{buttonLabel}}</span> <template v-if="!badge">({{amount}})</template>
    </v-btn>
</template>

<script>
export default {
    name: 'BasketAmount',
    props: {
        floatingBasket: {
            type: Boolean,
            default: false,
        },
        basketIcon: {
            default: 'shopping_cart',
        },
        basketEmptyIcon: {
            default: 'shopping_cart',
        },
        badgeBottom: {
            default: false,
        },
        badgeColor: {
            default: 'accent',
        },
        isButtonIcon: {
            type: Boolean,
            default: true,
        },
        isButtonRipple: {
            type: Boolean,
            default: true,
        },
        buttonLabel: String,
        badge: {
            type: Boolean,
            default: true,
        },
        iconColor: String,
    },
    data() {
        return {
            amount: 0,
        };
    },
    computed: {
        basketItems() {
            const result = [];
            const items = Object.values(this.$basket.getBasketItems(true));
            for (const item of items) {
                const product = this.$basket.getBasketItemProduct(item);
                if (product) {
                    item.product = product;
                    result.push(item);
                }
            }
            return items;
        },
    },
    methods: {
        onClick() {
            if (this.floatingBasket && this.$store.state['FloatingBasket']) {
                this.$store.commit('FloatingBasket/setShowFloatingBasket', true);
            } else {
                this.$router.push({
                    name: 'basket',
                });
            }
        },
        calculateAmount() {
            let amount = 0;
            for (const item of this.basketItems) {
                if (this.$basket.isCoupon(item.product)) {
                    amount++;
                } else {
                    if (item.quantity) {
                        amount += item.quantity;
                    }
                }
            }
            this.amount = amount;
        },
    },
    watch: {
        basketItems: {
            handler() {
                this.calculateAmount();
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>
